<template>
  <div>
    <div class="header">
      <slot name="header">
        <h4 class="title">{{ title }}</h4>
        <p class="category">{{ subTitle }}</p>
        <p class="category">Qnt: {{ data ? data.length : 0 }}</p>
      </slot>
    </div>

    <modal name="openImages" :adaptive="true">
      <div class="modal-background">
        <div class="details-modal">
          <div class="details-modal-close" v-on:click="closeCarousel">
            ❌
          </div>
          <div class="details-modal-title">
            <h1>Imagens do anúncio</h1>
          </div>
          <div class="details-modal-content">
            <carousel-3d
              style="background-color:white; border: none; outline: none; margin-top: -100px;"
              :width="1200"
              :height="1000"
              :display="3"
              :controls-visible="true"
              :controlsNextHtml="controlsNextHtml"
              :controlsPrevHtml="controlsPrevHtml"
            >
              <slide
                v-for="(slide, i) in CarImages"
                :index="i"
                :key="i"
                style="border: none;"
              >
                <template
                  slot-scope="{ index, isCurrent, leftIndex, rightIndex }"
                >
                  <img
                    :data-index="index"
                    :class="{
                      current: isCurrent,
                      onLeft: leftIndex >= 0,
                      onRight: rightIndex >= 0,
                    }"
                    :src="slide.imageURL"
                    style="object-fit: contain; width: 100%; height: 100%; background-color:white; border: none; outline: none;"
                  />
                </template>
              </slide>
            </carousel-3d>
          </div>

          <div class="details-modal-overlay"></div>
        </div>
      </div>
    </modal>
    <div class="content table-responsive table-full-width">
      <table class="table" :class="tableClass">
        <thead>
          <tr>
            <th v-if="checkOn">
              <input
                type="checkbox"
                v-model="checkAll"
                @click="toggleSelect(checkAll)"
              />
            </th>
            <th
              v-for="header in headers"
              v-on:click="getNamebyIndex(headers.indexOf(header))"
              :class="[
                {
                  headerSelectAsc: headerOrder == header && tipoOrder == 'Asc',
                },
                {
                  headerSelectDesc:
                    headerOrder == header && tipoOrder == 'Desc',
                },
              ]"
            >
              {{ header }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in getData"
            :class="selectId == item.id ? 'selectRow' : ''"
          >
            <td v-if="checkOn">
              <input
                type="checkbox"
                v-model="item.checked"
                v-on:click="SelectOne(item)"
              />
            </td>

            <td
              v-for="column in columns"
              v-if="hasValue(item, column)"
              v-on:click="sendEvent(item, column)"
              v-html="itemValue(item, column)"
            ></td>

            <td align="left" v-if="buttonsConfirm.length > 0">
              <img
                v-for="buttom in buttonsConfirm"
                :src="buttom.icon"
                v-on:click="execute(buttom.event, item)"
                style="margin: 5px"
              />
            </td>

            <td align="left" v-if="buttons.length > 0">
              <img
                v-for="buttom in buttons"
                :src="buttom.icon"
                v-on:click="execute(buttom.event, item)"
                style="margin: 5px"
              />
            </td>

            <td v-for="ctrl in control" align="right">
              <button
                v-on:click="execute(ctrl.event, item)"
                :class="ctrl.class"
              >
                {{ ctrl.texto }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";

Vue.use(Carousel3d);

import _ from "lodash";

export default {
  name: "component-table",
  components: {
    Carousel3d,
    Slide,
  },
  props: {
    headers: Array,
    columns: Array,
    data: Array,
    type: {
      type: String, // striped | hover
      default: "striped",
    },
    title: {
      type: String,
      default: "",
    },
    eventName: {
      type: String,
      default: "",
    },
    eventNameData: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    control: {
      type: Array,
      default: function() {
        return [];
      },
    },

    imageViewerData: {
      type: Array,
      default: function() {
        return [];
      },
    },

    buttons: {
      type: Array,
      default: function() {
        return [];
      },
    },
    buttonsConfirm: {
      type: Array,
      default: function() {
        return [];
      },
    },
    checkOn: {
      type: Boolean,
    },
  },
  data() {
    return {
      CarImages: null,
      currentCarId: "",
      current: 0,
      checkAll: false,
      columnOrder: "",
      headerOrder: "",
      tipoOrder: "Desc",
      selectId: "",
      dataAux: [],
      controlsNextHtml:
        '<div style="color: green; font-size: 24px;">&#9654;</div>',
      controlsPrevHtml:
        '<div style="color: green; font-size: 24px;">&#9664;</div>',
    };
  },
  computed: {
    tableClass() {
      return `table-${this.type}`;
    },

    getData() {
      this.dataAux = this.data;
      this.orderArray(false);
      return this.dataAux;
    },
  },

  methods: {
    orderArray(change) {
      if (this.columnOrder != "") {
        if (change == true) {
          if (this.tipoOrder == "Desc") {
            this.tipoOrder = "Asc";
            this.dataAux = _.sortBy(this.data, this.columnOrder);
          } else {
            this.tipoOrder = "Desc";
            this.dataAux = _.sortBy(this.data, this.columnOrder).reverse();
          }
        } else {
          if (this.tipoOrder == "Desc") {
            this.tipoOrder = "Desc";
            this.dataAux = _.sortBy(this.data, this.columnOrder).reverse();
          } else {
            this.tipoOrder = "Asc";
            this.dataAux = _.sortBy(this.data, this.columnOrder);
          }
        }
      }
    },

    closeCarousel() {
      this.$modal.hide("openImages");
      this.current = 0;
    },
    // closeCarousel() {
    //   this.image = false;
    //   this.current = 0;
    // },
    selectSlide(index) {
      this.current = index;
      // Outras lógicas necessárias ao selecionar um slide
    },

    openImageViewer(images) {
      this.CarImages = images;
      this.$modal.show("openImages");

      // if (images > 0) {
      //   this.$parent.$emit("openImageViewer", images);
      // }
    },

    getNamebyIndex(columnIndex) {
      this.columnOrder = this.columns[columnIndex];
      this.headerOrder = this.headers[columnIndex];
      this.orderArray(true);
    },
    hasValue(item, column) {
      return item[column] !== "undefined";
    },

    itemValue(item, column) {
      if (!column) return "";
      return this.getValue(item, column);
    },
    sendEvent(data, column) {
      console.log(column);
      if (column.columnName == "CarImages") {
        this.openImageViewer(data.CarImages);
      }
      if (typeof column === "object" && column.onclick) {
        column.onclick.call(this, data);
      } else if (this.eventName) {
        this.selectId = data.id;
        this.$parent.$emit(this.eventName, data, column);
      }
    },
    sendEventData(data) {
      if (this.eventNameData) {
        this.$parent.$emit(this.eventNameData, data);
      }
    },

    SelectOne(data) {
      if (!data.checked) {
        data.checked = true;
      } else {
        data.checked = false;
      }
    },

    toggleSelect: function(checkall) {
      if (!checkall) {
        this.dataAux.forEach(function(user) {
          Vue.set(user, "checked", true);
        });
      } else {
        this.dataAux.forEach(function(user) {
          Vue.set(user, "checked", false);
        });
      }
    },

    getColumnName(obj) {
      if (typeof obj === "string") return obj;
      return obj.columnName;
    },
    getValue(item, column) {
      let columnName = this.getColumnName(column);
      let colList = columnName.split(".");
      let value = item;
      for (let i of colList) {
        if (typeof value === "undefined" || value === null) {
          return null;
        }
        let idx = parseInt(i);
        idx = isNaN(idx) ? i : idx;
        value = value[idx];
      }
      if (typeof value === "undefined" || value === null) {
        return null;
      }

      return this.configValue(value, column);
    },
    configValue(value, columnData) {
      if (typeof columnData === "string") {
        // if(columnData.toUpperCase().indexOf('IMEI') !== -1){
        //   let path = window.location.pathname === '/' ? '' : window.location.pathname;
        //   return `<a href="${path}/?#/admin/blacklist/imei/${value}">${value}</a>`
        // }
        return value;
      }
      if (columnData.prefix) {
        value = `${columnData.prefix} ${value}`;
      }
      if (columnData.logic && typeof columnData.logic === "function") {
        value = columnData.logic(value, columnData);
      }
      return value;
    },
    execute(event, data) {
      if (event) {
        this.$parent.$emit(event, data);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.table-striped tbody > tr {
  cursor: pointer;
}
.table-striped thead > tr {
  cursor: pointer;

  :hover {
    background-color: #c2d4da57;
  }
}
.selectRow {
  background-color: #c2d4da57 !important;
}
.headerSelectAsc {
  background-color: #c2d4da57;
}
.headerSelectDesc {
  background-color: #9cb2b957;
}

.table-striped tbody > tr:nth-of-type(2n + 1):hover {
  background-color: #68b3c857;
}

.table-striped tbody > tr:nth-of-type(2n) {
  background-color: #f0f0f0;
}

.table-striped tbody > tr:nth-of-type(2n):hover {
  background-color: #68b3c857;
}

td,
th {
  padding: 5px 8px;
}

@media only screen and (max-width: 991px) {
  .card .content {
    padding: 15px 0px;
  }

  .table-responsive {
    border: none !important;
  }
}

.tooltip {
  z-index: 9999 !important;

  .tooltip-inner {
    background: black;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden="true"] {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
  }

  &[aria-hidden="false"] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.15s;
  }
}

.modal-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

/* Estilo para o modal */
.details-modal {
  padding: 2em;
  position: fixed;
  z-index: 9999;
  background: #fff;
  border-radius: 0.5em;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  left: 50%;
  max-width: 90%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  text-align: left;
  max-height: 80%;
  display: flex;
  flex-direction: column;

  &:focus {
    outline: none;
  }
  &::-webkit-details-marker {
    display: none;
  }
}

/* Estilo para o fundo escuro quando o modal estiver aberto */
.details-modal.open + .details-modal-overlay {
  display: block;
}

/* Estilo para desabilitar o conteúdo de fundo quando o modal estiver aberto */
.details-modal.open + .details-modal-overlay + * {
  pointer-events: none;
  opacity: 0.5;
}
// -------------- CLOSE

.details-modal-close {
  align-items: center;
  display: flex;
  margin-top: -32px;
  margin-right: 45px;
  height: 2em;
  justify-content: center;
  cursor: pointer;
  position: fixed;
  z-index: 1000;
  right: 0;
  font-size: 15px;
}

// -------------- TITLE

.details-modal-title {
  color: #fff;
  padding-bottom: 8px;
  pointer-events: all;
  position: relative;
  width: 105%;
  background-color: #43aeff;
  margin-top: -60px;
  margin-left: -42px;
  border-radius: 10px;

  h1 {
    font-size: 2.5rem;
    font-weight: 700;
    display: flex;
    justify-content: center;
  }
}

.details-modal-subtitle {
  color: #111827;
  margin-bottom: 1em;
  pointer-events: all;
  position: relative;
  width: calc(100% - 4.5em);
  border-bottom: 1px solid #e0e0e0;
}

// -------------- CONTENT

.details-modal-content {
  border-top: 3px solid #e0e0e0;
  padding: 2em;
  pointer-events: all;
  overflow: auto;
}

.text-content {
  line-height: normal;
  margin-bottom: 0.8em;
  font-weight: 600;

  color: #9a9a9a;
}

// -------------- OVERLAY

.details-modal-overlay {
  transition: opacity 0.2s ease-out;
  pointer-events: none;
  background: rgba(#0f172a, 0.8);
  position: fixed;
  opacity: 0;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;

  details[open] & {
    pointer-events: all;
    opacity: 0.5;
  }
}

.carousel-control-prev,
.carousel-control-next {
  color: green !important;
}

.carousel-control-prev:hover,
.carousel-control-next:hover {
  color: darkgreen !important;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Lists/ComponentTable.vue